import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SchoolTwoColumnLayoutModule } from 'Src/ng2/school/layouts/school-two-column-layout/school-two-column-layout.module';
import { SettingsLeftNavModule } from './../settings-left-nav/settings-left-nav.module';
import { SettingsLayoutComponent } from './settings-layout.component';
import { PageBannerModule } from '../../page-banner/page-banner.module';
import { NvIconModule } from 'projects/shared/nvps-libraries/design/nv-icon/nv-icon.module';
import { ExitViewModule } from '../../exit-view/exit-view.component.module';
import { NvSharedTooltipModule } from 'projects/shared/nvps-libraries/design/nv-tooltip/nv-shared-tooltip.module';
@NgModule({
  declarations: [SettingsLayoutComponent],
  imports: [
    CommonModule,
    RouterModule,
    SchoolTwoColumnLayoutModule,
    SettingsLeftNavModule,
    PageBannerModule,
    NvIconModule,
    ExitViewModule,
    NvSharedTooltipModule,
  ],
  exports: [SettingsLayoutComponent],
  providers: [],
})
export class SettingsLayoutModule {}
